import React from 'react'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import {
  FacilityItemDescription,
  FacilityItemText,
} from './FacilityItem.styled'
import { Appointment } from 'services/appointment'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

const FacilityItem: React.FC<{ appointment: Appointment }> = ({
  appointment,
}) => {
  const { replace } = useHistory()
  const formattedDate = moment(appointment.start_time).format(
    'MM/DD/YYYY hh:mma'
  )
  return (
    <TableItemContainer
      style={{ cursor: 'pointer' }}
      onClick={() =>
        replace(`/locations/${appointment.location_id}/reservations`)
      }>
      <TableItemBody justify="center">
        <FacilityItemText>{appointment.location.name}</FacilityItemText>
      </TableItemBody>
      <TableItemBody justify="center">
        <FacilityItemDescription>{formattedDate} </FacilityItemDescription>
      </TableItemBody>
    </TableItemContainer>
  )
}

export default FacilityItem
